import { Sparkles, Linkedin, Twitter, Github } from "lucide-react";

const COLS = [
  {
    title: "About",
    links: ["Company", "Careers", "Newsroom", "Contact"],
  },
  {
    title: "Solutions",
    links: [
      "AI Customer Service",
      "Omnichannel",
      "AI Chatbot",
      "Smart Ticketing",
    ],
  },
  {
    title: "Industries",
    links: ["E-commerce", "Financial Services", "Healthcare", "Retail"],
  },
  {
    title: "Resources",
    links: ["Documentation", "Blog", "Guides", "API Reference"],
  },
];

export default function Footer() {
  return (
    <footer
      id="resources"
      className="relative bg-white border-t border-[#EEF1F4] pt-20 pb-10"
      data-testid="footer"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10 lg:gap-8">
          <div className="col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#374151] text-white">
                <Sparkles className="h-4 w-4" />
              </span>
              <span className="font-display font-bold text-lg tracking-tight text-[#1F2937]">
                SOBOT
              </span>
            </a>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#6B7280]">
              Empowering global customer engagement with AI. All-in-one contact
              center and AI enterprise solutions for modern businesses.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Linkedin, Twitter, Github].map((Icon, i) => (
                <a
                  key={i}
                  href="#top"
                  data-testid={`social-${i}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F5F6F8] text-[#6B7280] hover:bg-[#374151] hover:text-white transition-colors duration-300"
                  aria-label="social link"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs uppercase tracking-[0.18em] font-semibold text-[#9CA3AF]">
                {col.title}
              </h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#top"
                      className="text-sm text-[#6B7280] hover:text-[#1F2937] transition-colors duration-300"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-[#EEF1F4] pt-8">
          <p className="text-sm text-[#9CA3AF]">
            © {new Date().getFullYear()} SOBOT TECHNOLOGIES PTE. LTD. All rights
            reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#top"
              className="text-sm text-[#6B7280] hover:text-[#1F2937] transition-colors duration-300"
            >
              Privacy Policy
            </a>
            <a
              href="#top"
              className="text-sm text-[#6B7280] hover:text-[#1F2937] transition-colors duration-300"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
